import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';
import axFile from 'src/store/configFile';


const initialState = {
    scheduleList: null,
    scheduleListLoading: false,
    scheduleUsersList: null,
    scheduleUsersListLoading: false,
};

export const scheduleAction = createAsyncThunk('scheduleAction', async (payload, { dispatch }) => {
    dispatch(setScheduleListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/schedule';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setScheduleListLoading(false))
                return data

            case 'post':
                ({ data } = await axFile.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Расписание успешно отредактировано`
                })
                break;

            case 'put':
                ({ data } = await axFile.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Расписание успешно добавлено`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Расписание успешно удалено`
                })
                break;
            case 'copy': 
                ({ data } = await ax.post(url+'/copy', payload.value ))
                data && openNotification({
                    type: 'success',
                    message: `Расписание успешно скопировано`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setScheduleListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const scheduleUserAction = createAsyncThunk('schedule/scheduleUsersAction', async (payload, { rejectWithValue }) => {
    try {
        let data;
        const url = '/api/admin/directory/scheduleUsers';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                return data
            case 'post':
                ({ data } = await ax.post(url, {}, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Расписание успешно отредактировано`
                })
                break;

            case 'put':
                ({ data } = await ax.put(url, {}, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Расписание успешно добавлено`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Расписание успешно удалено`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        return rejectWithValue(`${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`)
    }
})

const ScheduleSlice = createSlice({
    name: 'schedule',
    initialState,
    reducers: {
        setScheduleListLoading: (state, action) => {
            state.scheduleListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(scheduleAction.fulfilled, (state, action) => {
            state.scheduleList = action.payload
        })
        builder.addCase(scheduleUserAction.fulfilled, (state, action) => {
            state.scheduleUsersList = action.payload
            state.scheduleUsersListLoading = false
        })
        builder.addCase(scheduleUserAction.pending, (state) => {
            state.scheduleUsersListLoading = true
        })
        builder.addCase(scheduleUserAction.rejected, (_, action) => {
            openNotification({
                type: 'error',
                message: action.payload
            })
        })
    }
});

export const { setScheduleListLoading } = ScheduleSlice.actions;

export default ScheduleSlice.reducer